import React, { useState } from 'react';
import Slider, { SliderProps } from '@mui/material/Slider';

import { ZoneScheduleUpdateDialog } from 'dialogs/zone';
import { ValueLabelComponent } from './value-label-component';

interface ZoneScheduleSliderProps extends SliderProps {
  value: number[];
  onChangeValue: (value: number[]) => void;
}

export const ZoneScheduleSlider = ({
  min = 0,
  max = 1440,
  step = 15,
  marks = [
    { value: 0, label: '12am' },
    { value: 480, label: '8am' },
    { value: 720, label: '12pm' },
    { value: 1020, label: '5pm' },
    { value: 1440, label: '11:59pm' },
  ],
  value,
  onChangeValue,
  ...rest
}: ZoneScheduleSliderProps) => {
  const [{ activeThumb, visible: visibleScheduleUpdateDialog }, setScheduleUpdateDialogState] = useState<{
    activeThumb: number;
    visible: boolean;
  }>({
    activeThumb: -1,
    visible: false,
  });

  const onDelete = (index: number) => {
    const newValue = [...value];
    newValue.splice(index, 1);

    onChangeValue(newValue);
  };

  const onSubmit = (updatedValue: number) => {
    const newValue = [...value];

    if (activeThumb > -1) {
      newValue[activeThumb] = updatedValue;
    }

    onChangeValue(newValue);
    setScheduleUpdateDialogState((prev) => ({ ...prev, visible: false }));
  };

  return (
    <>
      <Slider
        min={min}
        max={max}
        marks={marks}
        step={step}
        track={false}
        valueLabelDisplay="on"
        value={value}
        onChange={(event: any, value: number | number[]) => {
          const newValue = Array.isArray(value) ? value : [value];
          onChangeValue(newValue);
        }}
        onBlur={(event: any) => {
          if (event.relatedTarget instanceof HTMLButtonElement) {
            // because of the focus on the input element,
            // when a button is clicked in the Tooltip while focus is on the input
            // the click event is never fired. So here we manually click it.
            event.relatedTarget.click();
          }
        }}
        components={{
          ValueLabel: ValueLabelComponent,
        }}
        componentsProps={{
          valueLabel: {
            setScheduleUpdateDialogState,
            deleteSchedule: onDelete,
          } as any,
        }}
        {...rest}
      />

      <ZoneScheduleUpdateDialog
        open={visibleScheduleUpdateDialog}
        onClose={() => setScheduleUpdateDialogState((prev) => ({ ...prev, visible: false }))}
        minutes={activeThumb >= 0 ? value[activeThumb] || 0 : 0}
        onSubmit={onSubmit}
      />
    </>
  );
};
